export const EstatusNotificacion = [
    {text: 'RESPONDIDA', value: 'RESPONDIDA'},
    {text: 'ANULADA', value: 'ANULADA'},
    {text: 'EN TRAMITE', value: 'EN TRAMITE'},
   
]